// 文件预览
export function mongeView(routerMap) {
  routerMap.dwgpro.component = () => import("@/views/mongeView/dwgProMax/index.vue");
  routerMap.modelpro.component = () => import("@/views/mongeView/modelProMax/index.vue");
  routerMap.cmnPdf.component = () => import("@/views/mongeView/docmentView/pdf.vue");
  routerMap.cmnTxt.component = () => import("@/views/mongeView/docmentView/txt.vue");
  routerMap.cmnOffice.component = () => import("@/views/mongeView/docmentView/office.vue");
  routerMap.cmnImage.component = () => import("@/views/mongeView/docmentView/image.vue");
  // routerMap.cmnMp4.component = () => import("@/views/mongeView/docmentView/mp4.vue");
}
